<template>
  <div class="pi-pile">
    <div class="pile-total">
      <div class="dc-box" @click="screenDev(3)">
        <div class="rate-type">
          <img src="../../../../assets/img/dc-text.png"
               alt="">
        </div>
        空闲{{details.dcFreeGunCount | formatNullValue}}<span class="total">/共{{details.dcGunTotalCount | formatNullValue}}</span>
      </div>
      <div class="ac-box" @click="screenDev(2)">
        <div class="rate-type">
          <img src="../../../../assets/img/ac-text.png"
               alt="">
        </div>
        空闲{{details.acFreeGunCount | formatNullValue}}<span class="total">/共{{details.acGunTotalCount | formatNullValue}}</span>
      </div>
    </div>
    <!-- <van-list v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"> -->
      <div class="list-item"
           v-for="(item, index) in list"
           :key="index"
           @click="gotoCharge(item)">
        <div class="pile-state-box">
          <div class="pile-state"
              :class="getStatusClass(item.gunStatus,item.deviceStatus)">
            <pi-soc-canvas v-if="item.gunStatus == 0 && item.soc" :soc="item.soc"></pi-soc-canvas>
            <div class="pile-state-inner-circle" v-else>
              <template v-if="item.deviceStatus == 1">
                {{item.deviceStatusDesc | formatNullValue}}
              </template>
              <template v-else>
                {{item.gunStatusDesc | formatNullValue}}
              </template>
            </div>
          </div>
          <div class="time" v-if="item.gunStatus == 0 && item.remainMinutes">约 {{item.remainMinutes | formatTime}} 充满</div>
        </div>
        <div class="pile-info">
          <div class="pile-info-name">
            <div>{{item.pileName | formatNullValue}}</div>
            <!-- <img :src="!item.speedType? require('../../assets/img/ic_slow.png') : require('../../assets/img/ic_fast.png')"
                 v-if="item.speedType!=null"> -->
          </div>
          <div class="pile-info-content">
            <span>{{item.gunName | formatNullValue}}枪</span>
            <span>{{item.pilePower | formatNullValue}}</span>
            <span>{{item.pileVoltage }}</span>
          </div>
          <!-- <div class="pile-info-number">编号：{{item.gunNumber}}</div> -->
        </div>
        <div class="pile-type-box">
          <div class="pile-type-dc"
               v-if="item.speedType">
            <img src="../../../../assets/img/dc-text.png"
                 alt="">
          </div>
          <div class="pile-type-ac"
               v-else>
            <img src="../../../../assets/img/ac-text.png"
                 alt="">
          </div>
        </div>
      </div>
      <div class="no-list-data" v-if="list.length == 0">暂无电桩</div>
    <!-- </van-list> -->
  </div>
</template>

<script>
import { List } from "vant";
import { getStationDetailPile, getOrderCurrent } from "@/common/api";
import socCanvas from '../soc-canvas/soc-canvas.vue'
export default {
  name: "pile2",
  components: {
    [List.name]: List,
    [socCanvas.name]: socCanvas,
  },
  data() {
    return {
      // active: 0,
      allList: [],
      list: [],
      // loading: false,
      // finished: false,
      staCharacter: null,
      gunNumberObj: {
        1: "A枪",
        2: "B枪",
      },
    };
  },
  filters: {
    geGunStatusDesc: function (value) {
      if (!value) {
        return "-";
      }
      switch (value) {
        case 0:
          return "空闲";
        case 1:
          return "充电";
        case 2:
          return "已预约";
        case 3:
          return "离线";
        case 4:
          return "故障";
      }
    },
  },
  props: {
    details: {
      type: Object,
      default: () => {
        return {};
      },
    },
    active: {
      type: Number,
      default : 0
    }
  },
  watch: {
    active(val){
      // console.log(val);
      if( val == 1){
        this.list = [];
        this.getList();
      }
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    // onLoad() {
    //   this.getList();
    // },
    screenDev(type){
      let list = [];
      this.allList.map(item=>{
        if(item.deviceType == type){
          list.push(item);
        }
      })
      this.list = list;
    },
    getList() {
      getStationDetailPile({
        staPkId: this.$route.query.staPkId,
      })
        .then((data) => {
          if (data.status === this.$config.ajaxStatus) {
            this.allList = data.data; 
            this.list = data.data;
          }
          // this.loading = false;
          // this.finished = true;
        })
        // .catch((error) => {
        //   this.loading = false;
        //   this.finished = true;
        //   console.log(error);
        // });
    },
    getStatusClass(status,deviceStatus) {
      if(deviceStatus == 1){
        // 下线
        return {offline: true}
      }else{
        return {
          free: !status || status == 7 || status == 1,
          charge: status === 8 || status === 0,
          hadOrder: status === 9,
          trouble: status === 2,
          offline: status === 3 || status === 4,
        };
      }
    },
    gotoCharge(item) {
      if (this.$route.params.staCharacter === 2) {
        //站点性质 0:自营，1：互联互通， 2：非互联互通
        this.$toast("此站点未签互联互通协议，不能充电");
        return;
      }
      if (
        item.gunStatus === 7 ||
        item.gunStatus === 1 ||
        item.gunStatus === 9
      ) {
        this.$router.push({
          name: "charge/ready",
          query: { gunPkId: item.gunPkId, operatorId: item.operatorId,customInfo:'',enterWay:0 },
        });
      }else if(item.gunStatus === 8 || item.gunStatus === 0){
        getOrderCurrent({gunPkId:item.gunPkId,pilePkId:item.pilePkId}).then((data) => {
          if (data.status === this.$config.ajaxStatus && data.data[0]) {
            if(item.gunStatus === 0){
              this.$router.push({
                name: "charge/charging",
                query: {
                  orderNo: data.data[0]
                }
              });
            }else{
              this.$router.push({
                name: "charge/finish",
                query: {
                  orderNo: data.data[0]
                }
              });
            }
          }
        })
      } else {
        this.$toast("请选择空闲的桩充电");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.pi-pile {
  background-color: #fff;
  
  .pile-total {
    text-align: center;
    background-color: #fafafa;
    padding: 0.1rem;
    margin: 0 0.1rem;
    .dc-box,
    .ac-box {
      vertical-align: top;
      display: inline-block;
    }
    .rate-type {
      color: #fff;
      padding: 0.04rem 0.03rem;
      box-sizing: border-box;
      height: 0.34rem;
      display: inline-block;
      vertical-align: middle;
      img {
        width: 0.5rem;
        height: 0.26rem;
        vertical-align: top;
      }
    }
    .ac-box {
      color: #14cc80;
      margin-left: 0.3rem;
      .rate-type {
        background-color: #14cc80;
      }
    }
    .dc-box {
      color: #ffa244;
      
      .rate-type {
        background-color: #ffa244;
      }
    }
    .total {
      color: #333;
    }
  }

  .list-item {
    display: flex;
    padding: 0.2rem 0.7rem 0.2rem 0.3rem;
    border-bottom: #dcdcdc 1px solid;
    .pile-state-box{
      .time{
        font-size: 0.18rem;
        line-height: 0.25rem;
        color: #FFA244;
        margin-top: 0.1rem;
        text-align: center;
      }
    }
    .pile-state {
      flex: 0 0 auto;
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      /*background: rgb(213, 72, 255);*/
      box-shadow: 0px 0px 8px 0px rgba(20, 204, 128, 0.4);
      padding: 0.06rem;
      &.free {
        color: #29d990;
        box-shadow: 0px 0px 8px 0px #29d990;
      }
      &.charge {
        color: #f8b16b;
        box-shadow: 0px 0px 8px 0px #f8b16b;
      }
      &.trouble {
        color: #f37a60;
        box-shadow: 0px 0px 8px 0px #f37a60;
      }
      &.offline {
        color: #cbcbcb;
        box-shadow: 0px 0px 8px 0px #cbcbcb;
      }
      &.hadOrder {
        color: #6fa1f6;
        box-shadow: 0px 0px 8px 0px #6fa1f6;
      }
      .pile-state-inner-circle {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 0.08rem solid currentColor;
        box-sizing: border-box;
        font-size: 0.24rem;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .pile-info {
      flex: 1;
      padding-left: 0.3rem;
      .pile-info-name {
        line-height: 0.4rem;
        padding-top: 0.09rem;

        color: #333333;
        display: flex;
        font-size: 0.28rem;
        justify-content: space-between;
        word-break: break-word;
        div {
          flex: 1;
        }
        img {
          width: 0.44rem;
          height: 0.44rem;
        }
      }
      .pile-info-content {
        line-height: 0.33rem;
        margin-top: 0.1rem;
        color: #666666;
        font-size: 0.24rem;
        span {
          margin-right: 0.2rem;
        }
      }
      .pile-info-number {
        line-height: 0.44rem;
        color: #666666;
        font-size: 0.24rem;
      }
    }
    .pile-type-box {
      display: flex;
      align-items: center;
      justify-items: center;
      .pile-type-dc,
      .pile-type-ac {
        padding: 0.04rem 0.03rem;
        background-color: #ffa244;
        height: 0.34rem;
        box-sizing: border-box;
        border-radius: 0.02rem;
      }
      .pile-type-ac {
        background-color: #14cc80;
      }
      img {
        width: 0.5rem;
        height: 0.26rem;
        vertical-align: top;
      }
    }
  }
}
</style>
